export default "__VITE_ASSET__CHlwicXK__"